// extracted by mini-css-extract-plugin
module.exports = {"btn":"UploadingStep_btn__3MQ68"};